var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DailyChallengeBase",
    [
      _c(
        "div",
        { staticClass: "daily-challenge-body" },
        [
          _c("DailyChallengeBody", {
            attrs: {
              "daily-challenge": _vm.dc,
              mainbody: _vm.mainbody,
              "is-locked": _vm.isLocked,
              "is-completed": _vm.isCompleted
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLocked
        ? _c(
            "div",
            { staticClass: "dp-archived-locked" },
            [
              _c("h3", { staticClass: "b-title-default" }, [
                _vm._v("This Daily Challenge has expired")
              ]),
              _vm._v(" "),
              _c("DcSubscribePremium")
            ],
            1
          )
        : _c("DailyChallengeProblem", {
            attrs: {
              "daily-challenge": _vm.dc,
              "is-locked": _vm.isLocked,
              "is-completed": _vm.isCompleted
            }
          }),
      _vm._v(" "),
      _vm.isLoading ? _c("div", { staticClass: "is-loading" }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }